import Cookies from 'js-cookie';
import fetchWithAuth from '@api/fetchWIthAuth';

import type { IGetCreativesData, IResponse } from '@api/types';
import { isGlobalDomain } from '@config/globalDomain';
import type { IForm, ICreativeState } from './interfaces';

import { ORD_FORM_TYPES } from './config';

export const prepareFormFields = (form: IForm, defaultCreativeName: string): IForm => ({
    type: 'deeplink',
    description: form.description || defaultCreativeName,
    link: form.link,
    offerId: form.offerId,
    placementId: form.placementId,
    ordForm: form.ordForm,
    ordDescription: form.ordDescription,
    ordRimDescription: form.ordRimDescription,
    ordText: form.ordText,
    ...(form.ordForm !== ORD_FORM_TYPES.text && { ordRim: form.ordRim }),
});

export const prepareCreativeData = (
    creativeData: IResponse<IGetCreativesData>,
    form: IForm,
    t: (key: string) => string,
): ICreativeState => {
    const {
        data: {
            attributes: { ordClientFullName, ordClientInn, code, erid },
        },
    } = creativeData;
    const INNText = isGlobalDomain ? 'TAX number/VAT number' : 'ИНН';
    const ordFullData = erid
        ? `${t('Advert')}: ${ordClientFullName} ${INNText}: ${ordClientInn}`
        : '';
    return {
        code,
        erid,
        ordFullData,
        link: form.link,
    };
};

// KY не отправляет formdata, вынесу в другую задачку
export const sendFormData = async (preparedForm: IForm): Promise<IResponse<IGetCreativesData>> => {
    const formData = new FormData();
    Object.keys(preparedForm).forEach(key => {
        formData.append(key, preparedForm[key]);
    });
    const response: Response = await fetchWithAuth(
        `${process.env.NEXT_PUBLIC_API_PREFIX}/creative/create`,
        {
            method: 'POST',
            headers: {
                'X-Access-Token': Cookies.get('jwt_access_token'),
                'X-Api-Version': '2.1',
            },
            body: formData,
        },
    );
    return response.json();
};
